import 'react-app-polyfill/ie9'
import 'core-js/features/array/find'
import 'core-js/features/array/includes'
import 'core-js/features/number/is-nan'
import 'babel-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import {
  ROUTER_BASE_PATH,
  DESKTOP_ROUTER_BASE_PATH,
  AR_DESKTOP_ROUTER_BASE_PATH,
  AR_ROUTER_BASE_PATH
} from 'AccountsConstants/routes'
import SupportPWA from './newComponents/SupportPage/supportPwa'
import SupportDesktop from './newComponents/SupportPage/supportDesktop'
import App from './App'
import AppDesktop from './AppDesktop'
import PageNotFound from './containers/PageNotFound'

ReactDOM.render((
  <BrowserRouter>
    <Switch>
      <Route path="/support" exact={true} component={SupportDesktop} />
      <Route path="/m/support" exact={true} component={SupportPWA} />
      <Route path={DESKTOP_ROUTER_BASE_PATH} component={AppDesktop} />
      <Route path={AR_DESKTOP_ROUTER_BASE_PATH} component={AppDesktop} />
      <Route path={ROUTER_BASE_PATH} component={App} />
      <Route path={AR_ROUTER_BASE_PATH} component={App} />
      <Route component={PageNotFound} />
    </Switch>
  </BrowserRouter>
), document.getElementById('root'))
